import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ColorSelector from '../common/form/colorSeletor';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Funcionario from './funcionario/funcionario';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';

import {
	setModoTela, initForm, salvar
} from './turmaActions';
import {
	setModoTela as setModoTelaFuncionario
} from './funcionario/funcionarioActions';

class TurmaForm extends Component {

	state = {

	}

	componentDidMount() {

		const fileSelectorImagem = document.createElement('input');

		fileSelectorImagem.setAttribute('type', 'file');
		fileSelectorImagem.setAttribute(
			'accept',
			'image/png,image/jpg,image/jpeg,.png,.jpg,.jpeg'
		);

		fileSelectorImagem.addEventListener('change', event => {

			const file = event.target.files && event.target.files[0]
				? event.target.files[0]
				: null;

			if (!file) {
				return;
			}

			if (
				!file.type.includes('image/png') &&
				!file.type.includes('image/jpg') &&
				!file.type.includes('image/jpeg')
			) {
				setError('Selecione apenas imagens (.PNG, .JPG e .JPEG)');
				event.target.value = '';
				return;
			}

			const reader = new FileReader();

			reader.onloadend = () => {

				const formularioValues =
					this.props.formularioValues || {};

				const lista = [
					...(formularioValues.imagem || [])
				];

				lista.push({
					imagem_base64: reader.result,
					nome_arquivo: file.name
				});

				this.props.initForm({
					...formularioValues,
					imagem: lista
				});

				event.target.value = '';
			};

			reader.onerror = () => {
				setError('Não foi possível ler a imagem da planilha');
				event.target.value = '';
			};

			reader.readAsDataURL(file);
		});

		this.fileSelectorImagem = fileSelectorImagem;
	}


	componentWillMount() {

	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';
		let acessoGestorAgencia = this.props.usuarioLogado && this.props.usuarioLogado.acesso_gestor_agencia;

		return (

			<>
				{this.props.funcionario ? (
					<>
						<ContentCard>
							<ContentCardBody>
								<Table responsive>
									<THead>
										<Tr>
											<Th >Empresa</Th>
											<Th >Profissional</Th>
											<Th alignCenter>Comp.</Th>
											<Th ></Th>
										</Tr>
									</THead>
									<TBody>
										<Tr>
											<Td>{this.props.registro.nome_empresa}</Td>
											<Td>{this.props.registro.nome_usuario}</Td>
											<Td alignCenter>{this.props.registro.competencia}</Td>
											<Td alignRight minWidth={100}>
												<ButtonTable
													type={'warning'}
													icon={'fas fa-arrow-left'}
													title='Voltar'
													visible={true}
													event={() => {
														this.props.setModoTela('lista', {});
														this.props.setModoTelaFuncionario('lista', {});
														this.props.initForm({});
													}} />
												{!acessoGestorAgencia &&
												<ButtonTable
													title={`${this.props.formularioValues.finalizado ? 'Reabrir' : 'Finalizar'}`}
													type={'success'}
													icon={`${this.props.formularioValues.finalizado ? 'fas fa-undo' : 'fas fa-check'}`}
													visible={true}
													disabled={this.props.usuarioLogado && this.props.usuarioLogado.administrador ? false : this.props.formularioValues.finalizado}
													event={() => {
														this.props.salvar({
															...this.props.formularioValues,
															finalizado: !this.props.formularioValues.finalizado
														});

													}} />}

											</Td>
											<Td>
											</Td>
										</Tr>
									</TBody>
								</Table>
							</ContentCardBody>
						</ContentCard>

						<Funcionario />
					</>
				) : (

					<ContentCard>
						<Form event={this.props.handleSubmit}>
							<ContentCardHeader>
								<Row alignCenter>
									<Grid cols='6 6 4 3'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
											<Button
												text='Salvar'
												submit
												type={'success'}
												icon={'fa fa-check'} />
										)}
									</Grid>
									<Grid cols='6 6 4 3'>
										<Button
											text='Voltar'
											type={'warning'}
											icon={'fa fa-chevron-left'}
											event={() => this.props.setModoTela('lista')} />
									</Grid>
								</Row>

							</ContentCardHeader>
							<ContentCardBody>
								<Row>
									<Select
										name='id_empresa'
										label='Empresa' placeholder='Informe a empresa '
										cols='12 6 4 4'
										readOnly={readOnly}
										options={this.props.listaEmpresa.filter(item => this.props.usuarioLogado ? this.props.usuarioLogado.administrador || item.id_usuario == this.props.usuarioLogado.id : false)}
										value={this.props.formularioValues.id_empresa}
										onChange={itemIndex => {
											let empresa = this.props.listaEmpresa.filter(item => item.id == itemIndex)[0];
											this.props.initForm({
												...this.props.formularioValues,
												id_empresa: itemIndex,
												id_usuario: empresa ? empresa.id_usuario : null
											})
										}} />


									<Field
										name='id_usuario'
										component={Select}
										label='Profissional' placeholder='Informe o profissional'
										cols='12 6 4 4'
										readOnly={this.props.usuarioLogado && this.props.usuarioLogado.administrador ? readOnly : 'readOnly'}
										options={this.props.listaUsuario}

									/>
								
									<Select
										name='competencia'
										label='Competência'
										placeholder='Selecione a competência'
										cols='12 6 4 4'
										readOnly={readOnly}
										value={this.props.formularioValues.competencia}
										options={(() => {

											const lista = [];

											const inicio = new Date(2022, 0, 1); // Janeiro/2022
											const hoje = new Date();

											const data = new Date(inicio);

											while (data <= hoje) {

												const competencia =
													`${String(data.getMonth() + 1).padStart(2, '0')}/${data.getFullYear()}`;

												lista.push({
													id: competencia,
													valor: competencia
												});

												data.setMonth(data.getMonth() + 1);
											}

											return lista.reverse(); // Mais recente primeiro

										})()}
										onChange={competencia => {
											this.props.initForm({
												...this.props.formularioValues,
												competencia
											});
										}}
									/>
								</Row>

								<Row>

									{/* SEMANA 1 */}

									<Grid cols='12 6 3 2'>
										<div
											style={{
												border: '1px solid #e2e8f0',
												borderRadius: 12,
												padding: 16,
												marginBottom: 16,
												background: '#f8fafc',
												boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
												minHeight: 280
											}}
										>
											<div
												style={{
													fontSize: 14,
													fontWeight: 700,
													color: '#0f172a',
													marginBottom: 0,
													paddingBottom: 8,
													borderBottom: '1px solid #e2e8f0',
													textAlign: 'center'
												}}
											>
												<Field
													name='semana1'
													component={LabelAndCheckbox}
													label='Semana 1' placeholder='Informe a semana 1'
													cols='12 12 12 12'
													readOnly={readOnly}
												/>
											</div>
											{this.props.formularioValues.semana1 &&
												<Row>
													<Field
														name='individual1'
														component={LabelAndCheckbox}
														label='Individual' placeholder='Informe'
														cols='12 12 12 12'
														readOnly={readOnly}
													/>
													<Field
														name='data_semana1'
														component={LabelAndInputMask}
														label='Data' placeholder='Informe a data'
														cols='12 12 12 12'
														mask={'99/99/9999'}
														readOnly={readOnly}
													/>
												</Row>}
										</div>
									</Grid>

									{/* SEMANA 2 */}

									<Grid cols='12 6 3 2'>
										<div
											style={{
												border: '1px solid #e2e8f0',
												borderRadius: 12,
												padding: 16,
												marginBottom: 16,
												background: '#f8fafc',
												boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
												minHeight: 280
											}}
										>
											<div
												style={{
													fontSize: 14,
													fontWeight: 700,
													color: '#0f172a',
													marginBottom: 0,
													paddingBottom: 8,
													borderBottom: '1px solid #e2e8f0',
													textAlign: 'center'
												}}
											>
												<Field
													name='semana2'
													component={LabelAndCheckbox}
													label='Semana 2' placeholder='Informe a semana 2'
													cols='12 12 12 12'
													readOnly={readOnly}
												/>
											</div>
											{this.props.formularioValues.semana2 &&
												<Row>
													<Field
														name='individual2'
														component={LabelAndCheckbox}
														label='Individual' placeholder='Informe'
														cols='12 12 12 12'
														readOnly={readOnly}
													/>
													<Field
														name='data_semana2'
														component={LabelAndInputMask}
														label='Data' placeholder='Informe a data'
														cols='12 12 12 12'
														mask={'99/99/9999'}
														readOnly={readOnly}
													/>
												</Row>}
										</div>
									</Grid>

									{/* SEMANA 3 */}

									<Grid cols='12 6 3 2'>
										<div
											style={{
												border: '1px solid #e2e8f0',
												borderRadius: 12,
												padding: 16,
												marginBottom: 16,
												background: '#f8fafc',
												boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
												minHeight: 280
											}}
										>
											<div
												style={{
													fontSize: 14,
													fontWeight: 700,
													color: '#0f172a',
													marginBottom: 0,
													paddingBottom: 8,
													borderBottom: '1px solid #e2e8f0',
													textAlign: 'center'
												}}
											>
												<Field
													name='semana3'
													component={LabelAndCheckbox}
													label='Semana 3' placeholder='Informe a semana 3'
													cols='12 12 12 12'
													readOnly={readOnly}
												/>
											</div>
											{this.props.formularioValues.semana3 &&
												<Row>
													<Field
														name='individual3'
														component={LabelAndCheckbox}
														label='Individual' placeholder='Informe'
														cols='12 12 12 12'
														readOnly={readOnly}
													/>
													<Field
														name='data_semana3'
														component={LabelAndInputMask}
														label='Data' placeholder='Informe a data'
														cols='12 12 12 12'
														mask={'99/99/9999'}
														readOnly={readOnly}
													/>
												</Row>}
										</div>
									</Grid>

									{/* SEMANA 4 */}

									<Grid cols='12 6 3 2'>
										<div
											style={{
												border: '1px solid #e2e8f0',
												borderRadius: 12,
												padding: 16,
												marginBottom: 16,
												background: '#f8fafc',
												boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
												minHeight: 280
											}}
										>
											<div
												style={{
													fontSize: 14,
													fontWeight: 700,
													color: '#0f172a',
													marginBottom: 0,
													paddingBottom: 8,
													borderBottom: '1px solid #e2e8f0',
													textAlign: 'center'
												}}
											>
												<Field
													name='semana4'
													component={LabelAndCheckbox}
													label='Semana 4' placeholder='Informe a semana 4'
													cols='12 12 12 12'
													readOnly={readOnly}
												/>
											</div>
											{this.props.formularioValues.semana4 &&
												<Row>
													<Field
														name='individual4'
														component={LabelAndCheckbox}
														label='Individual' placeholder='Informe'
														cols='12 12 12 12'
														readOnly={readOnly}
													/>
													<Field
														name='data_semana4'
														component={LabelAndInputMask}
														label='Data' placeholder='Informe a data'
														cols='12 12 12 12'
														mask={'99/99/9999'}
														readOnly={readOnly}
													/>
												</Row>}
										</div>
									</Grid>

									{/* SEMANA 5 */}

									<Grid cols='12 6 3 2'>
										<div
											style={{
												border: '1px solid #e2e8f0',
												borderRadius: 12,
												padding: 16,
												marginBottom: 16,
												background: '#f8fafc',
												boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
												minHeight: 280
											}}
										>
											<div
												style={{
													fontSize: 14,
													fontWeight: 700,
													color: '#0f172a',
													marginBottom: 0,
													paddingBottom: 8,
													borderBottom: '1px solid #e2e8f0',
													textAlign: 'center'
												}}
											>
												<Field
													name='semana5'
													component={LabelAndCheckbox}
													label='Semana 5' placeholder='Informe a semana 5'
													cols='12 12 12 12'
													readOnly={readOnly}
												/>
											</div>
											{this.props.formularioValues.semana5 &&
												<Row>
													<Field
														name='individual5'
														component={LabelAndCheckbox}
														label='Individual' placeholder='Informe'
														cols='12 12 12 12'
														readOnly={readOnly}
													/>
													<Field
														name='data_semana5'
														component={LabelAndInputMask}
														label='Data' placeholder='Informe a data'
														cols='12 12 12 12'
														mask={'99/99/9999'}
														readOnly={readOnly}
													/>
												</Row>}
										</div>
									</Grid>

								</Row>

								<Row>
									<Grid cols='12 12 12 12'>
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
												marginBottom: 12
											}}
										>
											<div>
												<div
													style={{
														fontSize: 16,
														fontWeight: 700,
														color: '#0f172a'
													}}
												>
													Planilha
												</div>

												<div
													style={{
														fontSize: 12,
														color: '#64748b',
														marginTop: 2
													}}
												>
													Adicione uma foto da planilha em PNG, JPG ou JPEG
												</div>
											</div>

											<span
												style={{
													background: '#eef2ff',
													color: '#4338ca',
													fontSize: 12,
													fontWeight: 600,
													padding: '6px 10px',
													borderRadius: 999
												}}
											>
												{(this.props.formularioValues.imagem || []).length} arquivo(s)
											</span>
										</div>
									</Grid>

									<Grid cols='12 12 12 12'>
										<div
											style={{
												display: 'flex',
												flexWrap: 'wrap',
												gap: 14
											}}
										>
											{(this.props.formularioValues.imagem || []).map((arquivo, i) => {

												const imagemPreview = arquivo.imagem_base64
													? arquivo.imagem_base64
													: (
														arquivo.imagem
															? `https://api-seft.infinitum-ti.com/${arquivo.imagem}`
															: imagemAdd
													);

												const nomeArquivo =
													arquivo.nome_arquivo ||
													(
														arquivo.imagem
															? arquivo.imagem.split('/').pop()
															: `Planilha ${i + 1}`
													);

												return (
													<div
														key={i}
														style={{
															width: 230,
															background: '#ffffff',
															border: '1px solid #e2e8f0',
															borderRadius: 14,
															overflow: 'hidden',
															boxShadow: '0 4px 14px rgba(15, 23, 42, 0.06)',
															transition: 'transform .2s ease, box-shadow .2s ease'
														}}
													>
														<div
															style={{
																height: 150,
																background: '#f8fafc',
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																overflow: 'hidden'
															}}
														>
															<img
																src={imagemPreview}
																alt={nomeArquivo}
																style={{
																	width: '100%',
																	height: '100%',
																	objectFit: 'cover'
																}}
															/>
														</div>

														<div
															style={{
																padding: 12
															}}
														>
															<div
																title={nomeArquivo}
																style={{
																	fontSize: 13,
																	fontWeight: 600,
																	color: '#0f172a',
																	whiteSpace: 'nowrap',
																	overflow: 'hidden',
																	textOverflow: 'ellipsis',
																	marginBottom: 10
																}}
															>
																{nomeArquivo}
															</div>

															<div
																style={{
																	display: 'flex',
																	gap: 8
																}}
															>
																<button
																	type='button'
																	className='btn btn-outline-primary'
																	style={{
																		flex: 1,
																		borderRadius: 8,
																		padding: '7px 10px'
																	}}
																	disabled={!arquivo.imagem}
																	title='Abrir imagem'
																	onClick={() => {
																		window.open(
																			`https://api-seft.infinitum-ti.com/${arquivo.imagem}`,
																			'_blank'
																		);
																	}}
																>
																	<i className='fas fa-external-link-alt' />
																</button>

																<button
																	type='button'
																	className='btn btn-outline-danger'
																	style={{
																		flex: 1,
																		borderRadius: 8,
																		padding: '7px 10px'
																	}}
																	title='Excluir imagem'
																	onClick={() => {
																		this.props.initForm({
																			...this.props.formularioValues,
																			imagem: (
																				this.props.formularioValues.imagem || []
																			).filter((_, indice) => indice !== i)
																		});
																	}}
																>
																	<i className='fas fa-trash-alt' />
																</button>
															</div>
														</div>
													</div>
												);
											})}

											<button
												type='button'
												onClick={() => this.fileSelectorImagem.click()}
												style={{
													width: 230,
													height: 224,
													border: '2px dashed #cbd5e1',
													borderRadius: 14,
													background: '#f8fafc',
													color: '#475569',
													display: 'flex',
													flexDirection: 'column',
													alignItems: 'center',
													justifyContent: 'center',
													gap: 10,
													cursor: 'pointer',
													transition: 'all .2s ease'
												}}
												onMouseEnter={event => {
													event.currentTarget.style.borderColor = '#3b82f6';
													event.currentTarget.style.background = '#eff6ff';
													event.currentTarget.style.color = '#2563eb';
												}}
												onMouseLeave={event => {
													event.currentTarget.style.borderColor = '#cbd5e1';
													event.currentTarget.style.background = '#f8fafc';
													event.currentTarget.style.color = '#475569';
												}}
											>
												<div
													style={{
														width: 54,
														height: 54,
														borderRadius: '50%',
														background: '#dbeafe',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center'
													}}
												>
													<i
														className='fas fa-camera'
														style={{
															fontSize: 24
														}}
													/>
												</div>

												<div
													style={{
														fontSize: 14,
														fontWeight: 700
													}}
												>
													Adicionar imagem
												</div>

												<div
													style={{
														fontSize: 11,
														color: '#64748b',
														textAlign: 'center',
														padding: '0 16px'
													}}
												>
													Clique para selecionar uma foto da planilha
												</div>
											</button>
										</div>
									</Grid>
								</Row>

								<br></br>

							</ContentCardBody>
							<ContentCardFooter>

							</ContentCardFooter>
						</Form>
					</ContentCard>
				)
				}
			</>



		)
	}


}

TurmaForm = reduxForm({ form: 'turmaForm', destroyOnUnmount: false })(TurmaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioLogado: state.auth.usuarioLogado,
	formularioValues: getFormValues('turmaForm')(state),
	registro: state.turma.registro,
	listaEmpresa: state.turma.listaEmpresa,
	listaUsuario: state.turma.listaUsuario,
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar,
	setModoTelaFuncionario
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(TurmaForm);
